/**
 * ccxt 에러 이름에 대한 사용자 친화적인 한국어 메시지 매핑
 */
export const CcxtErrorMessages: Record<string, string> = {
  // 인증 관련
  AuthenticationError: 'API 키 인증에 실패했습니다. API 키 설정을 확인해주세요.',
  PermissionDenied: 'API 키 권한이 부족합니다. 거래소에서 API 권한을 확인해주세요.',
  AccountNotEnabled: '계정이 활성화되지 않았습니다. 거래소에서 계정 상태를 확인해주세요.',
  AccountSuspended: '계정이 정지되었습니다. 거래소에 문의해주세요.',

  // 주문 관련
  InvalidOrder: '주문 정보가 올바르지 않습니다.',
  OrderNotFound: '주문을 찾을 수 없습니다.',
  DuplicateOrderId: '중복된 주문 ID입니다.',
  InsufficientFunds: '잔고가 부족합니다.',
  OrderImmediatelyFillable: '즉시 체결 가능한 주문입니다. 주문 조건을 확인해주세요.',
  OrderNotFillable: '체결할 수 없는 주문입니다.',

  // 요청 관련
  BadRequest: '잘못된 요청입니다.',
  BadSymbol: '잘못된 종목입니다.',
  BadResponse: '거래소에서 잘못된 응답을 받았습니다.',
  ArgumentsRequired: '필수 입력값이 누락되었습니다.',

  // 네트워크 관련
  NetworkError: '네트워크 오류가 발생했습니다. 인터넷 연결을 확인해주세요.',
  RequestTimeout: '요청 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.',
  ExchangeNotAvailable: '거래소 서버에 연결할 수 없습니다.',
  OnMaintenance: '거래소가 점검 중입니다. 잠시 후 다시 시도해주세요.',

  // 제한 관련
  RateLimitExceeded: 'API 요청 한도를 초과했습니다. 잠시 후 다시 시도해주세요.',
  DDoSProtection: 'DDoS 보호로 인해 요청이 차단되었습니다. 잠시 후 다시 시도해주세요.',
  InvalidNonce: '시스템 시간이 서버 시간과 일치하지 않습니다. 시스템 시간을 확인해주세요.',

  // 기타
  ExchangeError: '거래소 오류가 발생했습니다.',
  NotSupported: '지원되지 않는 기능입니다.',
  ContractUnavailable: '계약을 사용할 수 없습니다.',
  InvalidAddress: '잘못된 주소입니다.',
};

/**
 * ccxt 에러 이름으로 사용자 친화적인 메시지를 반환
 */
export function getCcxtErrorMessage(errorName: string): string | undefined {
  return CcxtErrorMessages[errorName];
}
